<template>
  <div class="noWrap">
    {{ getValue }}
  </div>
</template>

<script>
import TelefoneFilter from 'Arch/filters/TelefoneFilter';

export default {
  name: 'DataTableTelefoneColumn',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    getValue() {
      return this.handleColumnValue(
        TelefoneFilter(
          this.value,
        ),
      );
    },
  },
  inject: {
    handleColumnValue: {
      default() {
        return (v) => v;
      },
    },
  },
};
</script>
